import ProductTypeFormPage from "./productType/ProductTypeFormPage";
import CompanyFormPage from "./pages/Company/CompanyFormPage";
import CompanyParametersFormPage from "./pages/Company/CompanyParametersFormPage";
import UserFormPage from "./user/application/UserFormPage";
import CheckpointFormPage from "./checkpoint/component/CheckpointFormPage";
import ReadpointFormPage from "./readpoint/ReadpointFormPage";
import BizLocationFormPage from "./bizLocation/BizLocationFormPage";
import CommissionerPage from "./pages/Commissioner/CommissionerPage";
import TransationViewPage from "./transaction/TransationViewPage";
import DeviceFormPage from "./pages/Device/DeviceFormPage";
import EPCTrackPage from "./pages/Asset/EPCTrackPage";
import TransactionNewPage from "./transaction/TransactionNewPage";
import ProfileFormPage from "./profile/ProfileFormPage";
import StockLevelFormPage from "./stockLevel/StockLevelFormPage";
import TemplatesDashboardFormPage from "./pages/DashboardTemplates/DashboardTemplatesFormPage";
import CheckpointReadpointSelect from "./checkpoint/component/CheckpointReadpointSelect";
import CheckpointProfileSelect from "./checkpoint/component/CheckpointProfileSelect";
import ListPage from "./customGrid/ListPage";
import GatewayFormPage from "./gateways/GatewayFormPage";
import NodesFormPage from "./gateways/node/NodesFormPage";
import ReadpointAntennaSelect from "./gateways/antennas/ReadpointAntennaSelect";
import MapFormPage from "./map/MapFormPage";
import PolygonFormPage from "./map/polygon/PolygonFormPage";
import EpcDistanceFormPage from "./map/epc-distance/EpcDistanceFormPage";
import CurrentPositionFormPage from "./map/currentPosition/CurrentPositionFormPage";
import IntegrationConfigurationFormPage from "./integration/configuration/IntegrationConfigurationFormPage";
import UserProfileSelectPage from "./user/application/UserProfileSelectPage";
import MaterialImportFormPage from "./material/MaterialImportFormPage";
import IntegrationUserFormPage from "./user/integration/IntegrationUserFormPage";
import IntegrationUserProfileSelectPage from "./user/integration/IntegrationUserProfileSelectPage";
import TransactionPendingPage from "./transaction/TransactionPendingPage";
import BluzonePage from "./bluzone/BluzonePage";
import NewDashboardPage from './pages/Dashborad/NewDashboardPage';
import {PortalPage} from './pages/PortalPage/PortalPage'
import {CheckpointPortalPage} from "./pages/PortalPage/CheckpointPortalPage/CheckpointPortal";
import {TransactionPortalPage} from './pages/PortalPage/Transaction/TransactionPortalPage'
import {DevNewSensePage} from './pages/Dev/DevNewSense'
import {StockLevelGridPage} from "./pages/StockLevel/StockLevelByProductTypePage";
import MovementOrderFormPage from "./movementOrder/MovementOrderFormPage";
import {DashboardParkEvolutionPage} from './pages/StockLevel/Dashboard/DashboardParkEvolutionPage'
import ReadpointUsersAccessPage from "./readpoint/ReadpointUsersAccessPage";
import {ReadpointCheckpointTargetPage} from "./pages/ReadpointCheckpointTargetPage/ReadpointCheckpointTargetPage";
import MovementOrderDetailsPage from "./movementOrder/MovementOrderDetailsPage";
import {AuditPage} from "./pages/AuditPage/AuditScreen";
import DispositionFormPage from "./disposition/DispositionFormPage";
import BizStepFormPage from "./bizStep/BizStepFormPage";
import InventoryDetailScreen from "./Inventory/InventoryDetailScreen";
import InventoryItemsScreen from "./Inventory/InventoryItemsScreen";
import NodeActionFormPage from "./gateways/node/NodeActionFormPage";
import InventoryFormScreen from "./Inventory/InventoryFormScreen";
import InventoryExecutionScreen from "./Inventory/InventoryExecutionScreen";
import CompanyConfigurationFormPage from "./CompanyConfigurations/CompanyConfigurationFormPage";
import AlertGroupFormPage from "./pages/Groups/AlertGroupFormPage";
import AlertsTriggerFormPage from "./pages/Alerts/AlertstriggerFormPage";
import {AlertDetailPage} from "./pages/Alerts/AlertDetailPage";
import AlertsChartPage from "./pages/Alerts/AlertsChartPage";
import NodeSensingScreen from "./sensing/NodeSensingScreen";
import {DevNewCloudSense} from "./pages/Dev/DevNewCloudSense";
import AssetByPolygon from "./pages/AssetByPolygon/AssetByPolygon";
import LsdScreen from "./pages/Lsd/LsdScreen";
import MobileApplicationForm from "./pages/MobileApplications/MobileApplicationForm";
import MobileApplicationsScreen from "./pages/MobileApplications/MobileApplicationsScreen";

const Route = (path, component, isPrivate = true, exact = true) => {
  return {path, component, isPrivate, exact};
};

export const AllRoutes = [

  Route('/company-configurations/new', CompanyConfigurationFormPage),
  Route('/company-configurations/:id/edit', CompanyConfigurationFormPage),

  Route('/biz-steps/new', BizStepFormPage),
  Route('/biz-steps/:id/edit', BizStepFormPage),

  Route('/dispositions/new', DispositionFormPage),
  Route('/dispositions/:id/edit', DispositionFormPage),

  Route('/list/:entity/:bizLocationId', ListPage),
  Route('/list/:entity/biz-locations/:bizLocationId', ListPage),
  Route('/list/:entity/biz-locations/:bizLocationId/product-types/:productTypeId', ListPage),

  Route('/biz-locations/new', BizLocationFormPage),
  Route('/biz-locations/:id/edit', BizLocationFormPage),

  Route('/movement-orders/new', MovementOrderFormPage),
  Route('/movement-order/:id', MovementOrderDetailsPage),
  // Route('/biz-transactions/new', BizTransactionFormPage),
  // Route('/biz-transactions/:id/products', BizTransactionProductFormPage),
  Route('/transactions/:id/pending', TransactionPendingPage),

  Route('/product-types/new', ProductTypeFormPage),
  Route('/product-types/:id/edit', ProductTypeFormPage),

  Route('/checkpoints/new', CheckpointFormPage),
  Route('/checkpoints/:id/edit', CheckpointFormPage),
  Route('/checkpoints/:id/readpoints', CheckpointReadpointSelect),
  Route('/checkpoints/:id/profiles', CheckpointProfileSelect),

  Route('/commissioner', CommissionerPage),

  Route('/alerts-chart', AlertsChartPage),
  Route('/latest-movements', LsdScreen),
  Route('/gateways/new', GatewayFormPage),
  Route('/gateways/:id/nodes', NodesFormPage),
  Route('/gateways/:id/edit', GatewayFormPage),

  Route('/companies/new', CompanyFormPage),
  Route('/companies/:id/edit', CompanyFormPage),
  Route('/companies/:id/parameters', CompanyParametersFormPage),

  Route('/current-position', CurrentPositionFormPage),

  Route('/devices/new', DeviceFormPage),

  Route('/epc-distance/new', EpcDistanceFormPage),

  Route('/integration-configurations/new', IntegrationConfigurationFormPage),
  Route('/integration-configurations/:id/edit', IntegrationConfigurationFormPage),

  Route('/profile', ProfileFormPage),

  Route('/readpoints/new', ReadpointFormPage),
  Route('/readpoints/:id/edit', ReadpointFormPage),
  Route('/readpoints/:id/antennas', ReadpointAntennaSelect),

  Route('/nodes/:id/edit', NodesFormPage),
  Route('/nodes/new', NodesFormPage),

  Route('/maps/new', MapFormPage),
  Route('/maps/:id/edit', MapFormPage),
  Route('/maps/:id/:entity', ListPage),

  Route('/nodes/:id/:entity', ListPage),

  Route('/maps/:mapId/polygons/new', PolygonFormPage),
  Route('/polygons/:id/edit', PolygonFormPage),

  Route('/nodes-actions/new', NodeActionFormPage),

  Route('/stock-levels/new', StockLevelFormPage),
  Route('/stock-levels/:id/edit', StockLevelFormPage),
  Route('/list/stock-levels/:bizLocationId', ListPage),

  Route('/dashboard-templates/new', TemplatesDashboardFormPage),
  Route('/dashboard-templates/:id/edit', TemplatesDashboardFormPage),

  Route('/transactions/new', TransactionNewPage),
  Route('/transactions/:id', TransationViewPage),

  Route('/track/:epc?', EPCTrackPage),

  Route('/users/new', UserFormPage),
  Route('/users/:id/edit', UserFormPage),
  Route('/users/:id/profiles', UserProfileSelectPage),

  Route('/integration-users/new', IntegrationUserFormPage),
  Route('/integration-users/:id/edit', IntegrationUserFormPage),
  Route('/integration-users/:id/profiles', IntegrationUserProfileSelectPage),

  Route('/list/:entity', ListPage),

  Route('/materials/import', MaterialImportFormPage),

  Route('/bluzone', BluzonePage),

  Route('/', NewDashboardPage),

  Route('/portals', PortalPage),

  Route('/portals/readpoints/:readpointId/checkpoints', CheckpointPortalPage),

  Route('/portals/readpoints/:readpointId/transactions', TransactionPortalPage),

  Route('/dev/new-sensing', DevNewSensePage),

  Route('/dev/new-cloud-sensing', DevNewCloudSense),

  Route('/dash/assets/polygon', AssetByPolygon),
  Route('/dash/mobile-applications', MobileApplicationsScreen),
  Route('/dash/mobile-applications/new', MobileApplicationForm),
  Route('/dash/mobile-applications/edit/:id', MobileApplicationForm),


  Route('/stock-levels/evolution', StockLevelGridPage),

  Route('/stock-levels/dashboard', DashboardParkEvolutionPage),

  Route('/automatic/portals/:readpointId?', ReadpointCheckpointTargetPage),


  Route('/alerts-triggers/new', AlertsTriggerFormPage),


  Route('/alerts-triggers/edit/:id', AlertsTriggerFormPage),

  Route('/notifications-groups/new', AlertGroupFormPage),

  Route('/notifications-groups/edit/:id', AlertGroupFormPage),


  Route('/alert/detail/:id', AlertDetailPage),

  Route('/readpoints/portals/:readpointId/users', ReadpointUsersAccessPage),

  Route('/audit/:epc', AuditPage),

  Route('/inventories/new', InventoryFormScreen),

  Route('/inventories/:inventoryId', InventoryDetailScreen),

  Route('/inventories/:inventoryId/items', InventoryItemsScreen),

  Route('/inventories/:inventoryId/execution', InventoryExecutionScreen),

  Route('/nodes-sensing/:nodeId', NodeSensingScreen)
];




// WEBPACK FOOTER //
// ./src/Routes.js